import React ,{useState,useRef} from 'react';
import {useHistory } from 'react-router-dom';
import {Link} from "react-router-dom";
const Header = ()=> {
  let history = useHistory();
  const [search,setSearch] = useState("");
  const [_isActiveSearch,setActiveSearch] = useState(false);
  const refSearch = useRef();
  const handelActiveSearch = ()=>{
    if(!_isActiveSearch){
      refSearch.current.focus();
    }
    else {refSearch.current.blur()
      setSearch("")
    };
    setActiveSearch(!_isActiveSearch)
  };
  const handelSearch =(event)=>{
    if (event.key === 'Enter') {
      if(search!=="") history.push(`/search/${search}`);
    }
  }
  const handelClickIcon =()=>{
    if(search===""){
      handelActiveSearch()
    }
    else{
      history.push(`/search/${search}`)
    }
  }
  return (
    <React.Fragment>
      <div className="l-search">
        <div className="lang">
        <Link to="/" className="clickable active">EN</Link>
        <a href="http://tunnelgraphic.com/fa" className="clickable">FA</a>
        </div>
        <div className={_isActiveSearch? "search active":"search"}>
          <span className="clickable" onClick={_isActiveSearch?handelClickIcon:handelActiveSearch}><i className="icon icon-magnifying-glass"></i></span>
          <div className="box">
            {/* <label>Search :</label>  */}
            <input ref={refSearch} value={search} placeholder="Search" onBlur={()=>setTimeout(() =>setActiveSearch(false),300) } onChange={(ev)=>setSearch(ev.target.value)} onKeyDown={ev=>handelSearch(ev)}/>
          </div>
        </div>
      </div>
      <div className="logo"><span className="logo clickable"></span></div>
    </React.Fragment>
  );
}

export default Header;
